// src/VersionChecker.js
import React, { useEffect } from "react";

export default function VersionChecker() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json?_=" + Date.now()); // prevent browser caching
        // console.log(response,"meta version");
        const meta = await response.json();
        // console.log(meta,"meta version");
        
        const currentVersion = localStorage.getItem("app_version");
        // console.log(currentVersion,"meta version");
        // console.log(meta?.version,"meta version");
        if (currentVersion !== meta?.version) {
          console.log("New version detected. Clearing cache and reloading...","meta version");

          // Clear Cache Storage if available
          if ("caches" in window) {
            const cacheNames = await caches.keys();
            for (const name of cacheNames) {
              await caches.delete(name);
            }
            console.log("Cache Storage cleared successfully.","meta version");
            // alert("1")
          } else {
            console.warn("Cache Storage API not supported in this browser.","meta version");
            // alert("0")
          }

          localStorage.setItem("app_version", meta?.version);
          window.location.reload(); // Reload to get the new version
        } else {
          console.log(meta?.version,"meta version");
          localStorage.setItem("app_version", meta?.version);
        }
      } catch (error) {
        console.warn("Version check failed", error);
      }
    };

    checkVersion();
  }, []);

  return null; // This component doesn't render anything visible
}
